<div class="poi">
    <a (click)="expanded = !expanded">
        <i class="fa-solid fa-lg" [ngClass]="expanded ? 'fa-circle-minus' : 'fa-circle-plus'"></i>

        <ng-container *ngIf="showDistance">
            <span class="milesaway">{{poi.MilesFromPOI | number: '1.1-1'}} Miles</span>
            <app-direction-arrow [direction]="poi.Direction"></app-direction-arrow>
            <span class="pointofinterestname"> {{poi.egpName}}</span>
        </ng-container>

        <span *ngIf="!showDistance" class="interesttopicname">{{poi.egpName}}</span>
    </a>

    <div class="pointofinterestcontent" *ngIf="expanded"> {{poi.egpContent}}</div>
</div>
